function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2 2)"
}, React.createElement("circle", {
  fill: "#009AD7",
  cx: 48,
  cy: 21.874,
  r: 4.054
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 48.451,
  cy: 46.648,
  r: 5.405
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 74.126,
  cy: 46.198,
  r: 4.054
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 22.324,
  cy: 46.649,
  r: 6.306
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 48.451,
  cy: 70.072,
  r: 6.307
}), React.createElement("g", null, React.createElement("path", {
  fill: "#194C73",
  d: "M94.544,1.456v93.088H1.456V1.456H94.544 M98-2H-2V98H98V-2L98-2z"
})));

var SvgDivergence = function SvgDivergence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "divergence",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDivergence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Divergence.897a2d17.svg";
export { ForwardRef as ReactComponent };